let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("8D6c1")).then(() => parcelRequire('h7eGp'));